import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-equipment-breakdown",
  templateUrl: "./equipment-breakdown.component.html",
})
export class EquipmentBreakdownComponent implements OnInit {
  constructor(private appservice: AppService) {}

  successMessage: any = "";
  errorMessage: any = "";
  pagenumber = 1;
  pagerecord = 10;
  equipmentBreakdown = [];
  count = 0;
  currentPage;

  pageChanged(event) {
    const data = {
      sortColumn: "",
      sortType: "",
      pageNumber: event.page,
      pageRecord: this.pagerecord,
      tcId: localStorage.getItem("testCenterId"),
      type: 1,
    };
    this.getEquipmentBreakdown(data);
  }

  ngOnInit() {
    const data = {
      sortColumn: "",
      sortType: "",
      pageNumber: this.pagenumber,
      pageRecord: this.pagerecord,
      tcId: localStorage.getItem("testCenterId"),
      type: 1,
    };
    this.getEquipmentBreakdown(data);
  }

  getEquipmentBreakdown(data) {
    this.equipmentBreakdown = [];
    this.appservice.getIcscheduleCancel(data).subscribe((res) => {
      this.count = res["count"];
      this.equipmentBreakdown = res["entity"];
    });
  }
}
